import action from "i18n/lang/es/action";
import common from "i18n/lang/es/common";
import error from "i18n/lang/es/error";
import invoice from "i18n/lang/es/invoice";
import languages from "i18n/lang/es/languages";
import login from "./login";
import selfcare from "./selfcare";

export const es = {
  action,
  common,
  invoice,
  languages,
  error,
  login,
  selfcare,
} as const;
